import { render } from "./SchedulesDrawerLabel.vue?vue&type=template&id=b756184a&scoped=true"
import script from "./SchedulesDrawerLabel.vue?vue&type=script&lang=js"
export * from "./SchedulesDrawerLabel.vue?vue&type=script&lang=js"

import "./SchedulesDrawerLabel.vue?vue&type=style&index=0&id=b756184a&scoped=true&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b756184a"]])

export default __exports__